import React from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import ChatRTMP from "./ChatRTMP";

const ChatPage = ({chatPreference}) => {
  return (
      <ChatRTMP chatPreference={chatPreference}/>
  );
};

export default ChatPage;
